import { Link } from "react-router-dom";


export default function Connexion({connexion, position}) {
    // states


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>
                <div className="d-flex flex-row">
                    <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={"/assets/imgs/blank.png"} alt="" />
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{connexion?.nom}</div>
                        <div className="widget-subheading">{connexion?.login}</div>
                    </div>
                </div>
            </td>
            <td>{connexion?.lib}</td>
            {/* <td>{connexion?.libesptrav}</td> */}
            {/* <td>{connexion?.identterm}</td> */}
            <td>{connexion?.adripconn}</td>
            <td>
                <div 
                    className={`badge mr-2 ${
                        (connexion?.etat === 1) ? 'badge-success' :
                        (connexion?.etat === 2) ? 'badge-danger' :
                        ''
                        }`
                    }>
                        {
                            (connexion?.etat === 1) ? 'Connected' : 
                            (connexion?.etat === 2) ? 'Ended' : 
                            ''
                        }
                </div>
            </td>
            {/* <td>{connexion?.datedebconn ? <ReactTimeAgo date={Date.parse(connexion?.datedebconn)} timeStyle="facebook" /> : ""}</td> */}
            <td className="text-center">
                <Link to={`/connexion/${connexion?.code}`} data-toggle="tooltip" title="View connexion" data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                    <i className="fa fa-eye"></i>
                </Link>
            </td>
        </tr>
    )
}